import { IconBack } from '../../Styled'
import { LoadingHintText, LoadingIndicator, LoadingIndicatorInner, Wrapper } from './Styled'
import themeAssetvideoLoadingLoadingSvg from '@theme/video-loading/loading.svg'

interface Props {
  onBack?: () => void
  showBackButton?: boolean
}

export default function Loading({ onBack, showBackButton = true }: Props) {
  return (
    <Wrapper>
      <img src={themeAssetvideoLoadingLoadingSvg} alt="" />
      <LoadingIndicator>
        <LoadingIndicatorInner />
      </LoadingIndicator>
      <LoadingHintText>精彩即将呈现</LoadingHintText>
      {showBackButton && <IconBack onClick={onBack} />}
    </Wrapper>
  )
}
